import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { getDefaultRoute } from '@/services/authService';

/** Redirige al dashboard correcto según los permisos del usuario. */
export function DefaultRedirect() {
  const { permissions } = useAuth();
  return <Navigate to={getDefaultRoute(permissions)} replace />;
}

/** Envuelve las rutas privadas: exige sesión, muestra spinner mientras carga. */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-slate-50">
        <Loader2 size={40} className="animate-spin text-brand" />
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}
